// extracted by mini-css-extract-plugin
module.exports = {"notification":"_3nQ4b","notification-wrapper":"_2I86b","notificationWrapper":"_2I86b","tooltip":"_2O1r9"};